/**
 * product-media-nav.js — wires the large overlay prev/next arrows on the
 * product page main image to the existing <media-gallery> setActiveMedia()
 * API. Works for every gallery_layout (stacked, thumbnail, thumbnail_slider)
 * on both desktop and mobile.
 *
 * The arrows are rendered inside <slider-component id="GalleryViewer-..."> by
 * snippets/product-media-gallery.liquid (look for [data-product-media-nav]).
 * They wrap around at the ends (last image → next click jumps back to first).
 *
 * Why not reuse the existing .slider-button arrows? Those scroll the slider
 * horizontally — which works on mobile but does nothing on desktop, because
 * desktop layouts put non-active slides as display:none rather than scrolled.
 * setActiveMedia() works in both modes.
 */

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('media-gallery').forEach(setupGallery);
  }

  function setupGallery(gallery) {
    var prev = gallery.querySelector('[data-product-media-nav="prev"]');
    var next = gallery.querySelector('[data-product-media-nav="next"]');
    if (!prev || !next) return;

    var items = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
    if (items.length < 2) return;

    prev.addEventListener('click', function (e) { e.preventDefault(); navigate(gallery, items, -1); });
    next.addEventListener('click', function (e) { e.preventDefault(); navigate(gallery, items,  1); });
  }

  function navigate(gallery, items, direction) {
    var active = gallery.querySelector('.product__media-item.is-active[data-media-id]') || items[0];
    var currentIdx = items.indexOf(active);
    if (currentIdx === -1) currentIdx = 0;
    var newIdx = (currentIdx + direction + items.length) % items.length;
    var nextMediaId = items[newIdx].dataset.mediaId;
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(nextMediaId, false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
